<template>
  <v-dialog
    v-if="isActive"
    :value="isActive"
    @click:outside="closeDialog()"
    max-width="600"
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Ingrese su extension para llamar
            </v-card-title>
          </v-img>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <ValidationProvider name="Extension" rules="required" v-slot="{ errors }">
                <v-autocomplete
                  v-model="callPayload.extension"
                  :error-messages="errors"
                  :items="extensionsList"
                  label="Extension"
                  prepend-inner-icon="mdi-call-split"
                  no-data-text="No hay extensiones para mostrar"
                  autofocus
                  persistent-placeholder
                  chips
                  rounded
                  filled
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="closeDialog()" color="error" text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            Llamar
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    isActive: {
      type: Boolean,
    },
    contactToCall: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      isLoading: false,
      extensionsList: [],
      callPayload: { extension: "" },
    };
  },
  created() {
    this.getExtensions();
  },
  methods: {
    closeDialog() {
      this.$emit("close:dialog");
    },

    async getExtensions() {
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get("/clients/listExtension");
        this.extensionsList = data;
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo obtener las extensiones.", "¡Error!");
      }
      this.isLoading = false;
    },

    async submitForm() {
      this.isLoading = true;
      try {
        await new Promise((res, rej) => {
          setTimeout(() => {
            res(true);
          }, 2000);
        });
        this.closeDialog();
        this.$snotify.success("Llamada realizada con exito", "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo establecer la llamada", "¡Error!");
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
